// import FormGroup from "app/Components/Form/FormGroup.component";
import SimpleSelect from "app/Components/SearchableSelect/SimpleSelect";
import InputError from "app/Components/_form/InputError/InputError";
import React from "react";
import { Col, Row, FormGroup } from "react-bootstrap";
import {
  employeeFormLabel,
  employeeMedicalCategoryList,
  employeeMedicalEligibilityList,
} from "../Constant";
import Label from "app/Components/_form/Label/Label";
import DatePicker from "app/Components/DateTimeCustom/CustomDateTime";

function MedicalForm({ form = {}, onChange, error, effectiveDateFlag }) {
  return (
    <Row className="mb-4 justify-content-start align-items-center">
      <Col md={4}>
        <FormGroup>
          <Label>{employeeFormLabel["specialMedicalExamCategory"]}</Label>

          <SimpleSelect
            name={"specialMedicalExamCategory"}
            value={form.specialMedicalExamCategory}
            onChange={onChange}
            options={employeeMedicalCategoryList}
            label={"name"}
            id="value"
            placeHolder={employeeFormLabel["specialMedicalExamCategory"]}
            // disabled={!form.specialMedicalExamEligibility}
          />
          <InputError error={error["specialMedicalExamCategory"]} />
        </FormGroup>
      </Col>
      <Col md={4}>
        <FormGroup>
          <Label>{employeeFormLabel["specialMedicalExamEligibility"]}</Label>

          <SimpleSelect
            name={"specialMedicalExamEligibility"}
            value={form.specialMedicalExamEligibility}
            onChange={onChange}
            options={employeeMedicalEligibilityList}
            placeHolder={employeeFormLabel["specialMedicalExamEligibility"]}
            label={"name"}
            id="value"
          />
          <InputError error={error["specialMedicalExamEligibility"]} />
        </FormGroup>
      </Col>
      {effectiveDateFlag && (
        <Col md={4}>
          <FormGroup>
            <Label>{employeeFormLabel["effectiveDate"]}</Label>

            <DatePicker
              name={"effectiveDate"}
              value={form.effectiveDate}
              onChangeDate={onChange}
              label={employeeFormLabel["effectiveDate"]}
              placeHolder={employeeFormLabel["effectiveDate"]}
              error={error["effectiveDate"]}
            />
            <InputError error={error["effectiveDate"]} />
          </FormGroup>
        </Col>
      )}
    </Row>
  );
}

export default MedicalForm;
